var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddText = function SvgAddText(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85046 0.0883918C6.90448 0.0420863 7.00859 0 7.20165 0H8.79829C8.97087 0 9.06947 0.0399364 9.126 0.0883918L9.1314 0.0930141L9.13708 0.0972756C9.22747 0.165073 9.29769 0.256374 9.34661 0.377993L15.1438 15.5633C15.1685 15.6387 15.1782 15.6998 15.1782 15.7484C15.1782 15.812 15.1569 15.8672 15.1011 15.923C15.0454 15.9788 14.9902 16 14.9266 16H13.7291C13.5824 16 13.5069 15.9653 13.4666 15.9287C13.4019 15.8498 13.3642 15.7867 13.3449 15.7388L13.3445 15.7379L12.0001 12.2667H3.99987L2.64773 15.7577L2.64404 15.7761C2.64075 15.7925 2.62096 15.8413 2.5393 15.923C2.50069 15.9616 2.42507 16 2.27083 16H1.07335C1.00973 16 0.954584 15.9788 0.898799 15.923C0.843014 15.8672 0.821777 15.812 0.821777 15.7484C0.821777 15.6898 0.827169 15.6229 0.838898 15.5471L6.65272 0.379506L6.65329 0.378102C6.70496 0.24945 6.77204 0.155609 6.85046 0.0883918ZM11.486 10.6834L7.99997 1.51659L4.51399 10.6834H11.486Z",
    fill: "#7D86A1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_text.6f03952b.svg";
export { ForwardRef as ReactComponent };